import { ParentConsentPopupState } from '@/model/ParentConsentPopupState'

const initialState: ParentConsentPopupState = {
  show: false,
}

export const parentConsentPopup = {
  namespaced: true,
  state: initialState,
  actions: {
    showPopup({ commit }: Record<any, any>) {
      commit('show')
    },
    hidePopup({ commit }: Record<any, any>) {
      commit('hide')
    },
  },
  mutations: {
    show(state: ParentConsentPopupState) {
      state.show = true
    },
    hide(state: ParentConsentPopupState) {
      state.show = false
    },
  },
}
